export default __webpack_public_path__ + "static/media/KRUSKALInfo.ba2468c0.md";